class ServerSideKubernetesAuthProvider {
  async decorateRequestBodyForAuth(requestBody) {
    return requestBody;
  }
  async getCredentials() {
    return {};
  }
}

export { ServerSideKubernetesAuthProvider };
//# sourceMappingURL=ServerSideAuthProvider.esm.js.map
